import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '@/integrations/supabase/client';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const genericError = 'Neplatné přihlašovací údaje nebo nemáte oprávnění.';
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      toast.error(genericError);
      setLoading(false);
      return;
    }
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      toast.error(genericError);
      setLoading(false);
      return;
    }
    const { data: roleData } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', user.id)
      .eq('role', 'admin')
      .maybeSingle();

    if (!roleData) {
      await supabase.auth.signOut();
      toast.error(genericError);
      setLoading(false);
      return;
    }
    toast.success('Přihlášení úspěšné!');
    navigate('/admin');
  };

  return (
    <>
      <Helmet>
        <title>Přihlášení do administrace | Tom Art Mask</title>
        <meta name="description" content="Přihlašovací stránka administrace Tom Art Mask. Pouze pro oprávněné uživatele." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://tomartmask.cz/admin/login" />
      </Helmet>
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
            <Lock className="text-primary" size={28} />
          </div>
          <h1 className="text-4xl tracking-wider text-foreground" style={{ fontFamily: 'Bebas Neue' }}>
            Admin Panel
          </h1>
          <p className="text-muted-foreground text-sm mt-2">
            Přihlášení do administrace
          </p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-card border-border"
          />
          <Input
            type="password"
            placeholder="Heslo"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="bg-card border-border"
          />
          <Button type="submit" className="w-full uppercase tracking-widest" disabled={loading}>
            {loading ? 'Přihlašování...' : 'Přihlásit se'}
          </Button>
        </form>
        <div className="text-center">
          <a href="/" className="text-muted-foreground hover:text-primary text-sm transition-colors">
            ← Zpět na web
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default AdminLogin;
